import React, { useEffect, useState } from 'react';

/**
 * Hook for handling context menu (right click)
 * @returns
 */
const useContextMenu = () => {
  const [contextMenuPosition, setContextMenuPosition] = useState({ x: 0, y: 0 });
  const [showContextMenu, setShowContextMenu] = useState<boolean>(false);
  const [contextMenuItems, setContextMenuItems] = useState([]);

  /**
   * Open context menu modal
   * @param event
   * @param items - options shown when context menu opens
   */
  const openContextMenu = (e: any, items: any) => {
    e.preventDefault();
    setContextMenuPosition({ x: e.clientX, y: e.clientY });
    setContextMenuItems(items);
    setShowContextMenu(true);
  };

  /**
   * Close context menu modal
   */
  const closeContextMenu = () => {
    setShowContextMenu(false);
  };

  /**
   * Action on click context menu item
   */
  const handleItemClick = (item: any) => {
    item.action();
    closeContextMenu();
  };

  useEffect(() => {
    /**
     * Close context menu on outside click
     * @param event
     */
    const handleOutsideClick = (event: any) => {
      if (showContextMenu && !event.target.closest('.context-menu')) {
        closeContextMenu();
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [showContextMenu]);

  /**
   * Set position of modal (position of mouse click)
   */
  const contextMenuStyle = {
    top: contextMenuPosition.y + 12,
    left: contextMenuPosition.x,
  };

  const ContextMenu = () => {
    return (
      <>
        {showContextMenu && (
          <ul
            className="context-menu absolute text-center bg-white shadow-sm min-w-[120px] list-none py-1 px-0 border border-gray-400 rounded-sm"
            style={contextMenuStyle}
          >
            {contextMenuItems.map((item: any, index) => (
              <li
                key={index}
                onClick={() => handleItemClick(item)}
                className="cursor-pointer p-0 color-black"
              >
                {item.label}
              </li>
            ))}
          </ul>
        )}
      </>
    );
  };

  return { openContextMenu, closeContextMenu, ContextMenu };
};

export default useContextMenu;
